const SET_ADDRESS_ID = "SET_ADDRESS_ID";
const SET_DAY_OF_WEEK = "SET_DAY_OF_WEEK";
const SET_FREQUENCY = "SET_FREQUENCY";
const SET_START_AT = "SET_START_AT";
const SET_END_AT = "SET_END_AT";
const SET_PROFESSIONALS = "SET_PROFESSIONALS";
const SET_PROFESSIONAL_ID = "SET_PROFESSIONAL_ID";
const SET_INFORMATION = "SET_INFORMATION";
const SET_TAKE_PRODUCTS = "SET_TAKE_PRODUCTS";
const SET_TOBE = "SET_TOBE";
const SET_STEP_CART = "SET_STEP_CART";

import moment from "@/utils/moment";

export default {
  namespaced: true,

  state: {
    to_be: null,
    address_id: null,
    dayOfWeek: null,
    frequency: null,
    start_at: null,
    end_at: null,
    professional_id: null,
    professionals: [],
    information: "",
    take_products: true,
    step_cart: false
  },

  actions: {
    setAddressId({ commit }, payload) {
      commit(SET_ADDRESS_ID, payload);
    },

    setToBe({ commit, dispatch }, payload) {
      commit(SET_TOBE, payload);
      if (payload === "professional") dispatch("searchProfessionals");
    },

    setProfessionals({ commit }, payload) {
      commit(SET_PROFESSIONALS, payload);
    },

    setStartAt({ state, commit, dispatch }, payload) {
      commit(SET_START_AT, payload);
      if (state.to_be === "schedule") dispatch("setProfessionals", []);
    },

    setEndAt({ state, commit, dispatch, getters }, payload) {
      if (
        state.start_at &&
        state.start_at < payload &&
        payload <= getters.maxEndAt
      ) {
        commit(SET_END_AT, payload);
        if (state.to_be === "schedule") dispatch("setProfessionals", []);
      }
    },

    setProfessionalId({ commit, dispatch, state }, payload) {
      if (state.to_be === "professional") {
        dispatch("setStartAt", null);
        dispatch("setEndAt", null);
      }

      commit(SET_PROFESSIONAL_ID, payload);
    },

    setInformation({ commit }, payload) {
      commit(SET_INFORMATION, payload);
    },

    setTakeProducts({ commit }, payload) {
      commit(SET_TAKE_PRODUCTS, payload);
    },

    setStepCart({ commit }, payload) {
      commit(SET_STEP_CART, payload);
    },

    searchProfessionals({ dispatch, state, rootGetters }) {
      var obj =
        state.to_be === "professional"
          ? rootGetters["professionals/favoriteProfessionals"]
          : rootGetters["professionals/professionalsBySchedule"];

      dispatch("setProfessionals", obj);
    },

    sendToCart({ dispatch, getters, state }) {
      var payload = {
        address_id: state.address_id,
        start_at: state.start_at,
        end_at: state.end_at,
        professional_id: state.professional_id,
        information: state.information,
        take_products: state.take_products,
        price: getters.price,
        duration: getters.duration
      };

      dispatch("setToBe", null);
      dispatch("setAddressId", null);
      dispatch("setStartAt", null);
      dispatch("setEndAt", null);
      dispatch("setProfessionalId", null);
      dispatch("setProfessionals", []);
      dispatch("setInformation", null);
      dispatch("setTakeProducts", true);
      dispatch("setStepCart", true);

      dispatch("orders/createOrder", payload, {
        root: true
      });
    }
  },

  mutations: {
    [SET_ADDRESS_ID](state, payload) {
      state.address_id = payload;
    },
    [SET_DAY_OF_WEEK](state, payload) {
      state.dayOfWeek = payload;
    },
    [SET_FREQUENCY](state, payload) {
      state.frequency = payload;
    },
    [SET_START_AT](state, payload) {
      state.start_at = payload;
      state.end_at = null;
    },
    [SET_END_AT](state, payload) {
      state.end_at = payload;
    },
    [SET_PROFESSIONALS](state, payload) {
      state.professionals = payload;
    },
    [SET_PROFESSIONAL_ID](state, payload) {
      state.professional_id = payload;
    },
    [SET_INFORMATION](state, payload) {
      state.information = payload;
    },
    [SET_TAKE_PRODUCTS](state, payload) {
      state.take_products = payload;
    },
    [SET_TOBE](state, payload) {
      state.to_be = payload;
      state.professional_id = null;
      state.start_at = null;
      state.end_at = null;
    },
    [SET_STEP_CART](state, payload) {
      state.step_cart = payload;
    }
  },

  getters: {
    duration(state) {
      return state.end_at && state.start_at
        ? state.end_at.substr(0, 2) - state.start_at.substr(0, 2)
        : null;
    },
    price(state) {
      var normal = null;
      var formated = null;

      if (state.start_at && state.end_at) {
        var duration = state.end_at.substr(0, 2) - state.start_at.substr(0, 2);

        normal = duration > 1 ? duration * 17 + 33.9 : 33.9;

        formated = "R$ " + normal.toFixed(2).replace(".", ",");
      }

      return { normal, formated };
    },
    textPeriod(state) {
      return state.end_at && state.start_at
        ? state.start_at.substr(0, 2) +
            "h às " +
            state.end_at.substr(0, 2) +
            "h"
        : "escolha um período";
    },
    textTakeProducts(state) {
      return state.take_products ? "Diarista leva" : "Próprios";
    },
    professional(state) {
      if (state.professional_id && state.professionals.length) {
        return state.professionals.find(x => x.id === state.professional_id);
      }
    },
    startAtFormated(state) {
      return state.start_at ? state.start_at.substr(0, 2) + "h" : "";
    },
    endAtFormated(state) {
      return state.end_at ? state.end_at.substr(0, 2) + "h" : "";
    },
    calendar(state) {
      var ranges = [];
      var last = moment()
        .add(1, "months")
        .toDate();

      if (
        state.professional_id &&
        state.professionals.length &&
        state.to_be === "professional"
      ) {
        var professional = state.professionals.find(
          x => x.id === state.professional_id
        );

        var schedules = professional.schedules.sort(function(a, b) {
          return a.day > b.day ? 1 : b.day > a.day ? -1 : 0;
        });

        for (var i = 0; schedules.length > i; i++) {
          var now = schedules[i].day;
          var prev = schedules[i - 1] ? schedules[i - 1].day : now;
          var obj = null;

          if (moment(now).diff(moment(prev), "days") > 1) {
            obj = {
              from: moment(prev)
                .add(1, "days")
                .toDate(),
              to: moment(now).toDate()
            };

            ranges.push(obj);
          }
        }

        last = moment(schedules[schedules.length - 1].day)
          .add(1, "days")
          .toDate();
      }

      return {
        to: moment()
          .subtract(1, "days")
          .toDate(),
        from: last,
        ranges
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/newSubscription.js